module.exports = __webpack_public_path__ + "img/igtech.d41d8cd9.svg";